import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import InterestRateUI from '../../../components/superUser/loan/assessment/InterestRateUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const InterestRatePageUI = ({ context, errorList, loan, loanInterestRate, onRefreshClick, toggleEditable, editable
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_intr' topnav='loans'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList || !loanInterestRate} loan={loan} page='interestRate'
    dimension='w768'
  >
    {
      (!loan || !errorList || !loanInterestRate) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan && loanInterestRate &&
      <InterestRateUI
        context={context}
        loan={loan}
        loanInterestRate={loanInterestRate}
        onRefreshClick={onRefreshClick}
        toggleEditable={toggleEditable}
        editable={editable}
      />
    }
  </SuperUserLoanPageUI>

export default InterestRatePageUI
